import React from 'react';
import Main from './pages/MainComponent';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}


export default App;
